interface ViewsData {
  favourites?: Array<{ name: string; uuid: string }>
  publicViews?: Array<{ name: string; uuid: string }>
  hasLiveConversationPermission?: boolean
}

/**
 * Helper function to get the first available conversation route for agents
 * This logic matches the sidebar conversation navigation priority
 *
 * Priority order:
 * 1. "All Conversations" view (if exists)
 * 2. Live conversations (if user has permission)
 * 3. First available view with valid UUID
 * 4. Fallback to /conversations/active/c
 */
export const getFirstAvailableConversationRoute = (viewsData?: ViewsData): string => {
  // First priority: Find "All Conversations" view
  const allConversationsInFavourites = viewsData?.favourites?.find(
    (view) => view.name === 'All Conversations',
  )
  const allConversationsInPublic = viewsData?.publicViews?.find(
    (view) => view.name === 'All Conversations',
  )
  const allConversationsView = allConversationsInFavourites || allConversationsInPublic

  if (allConversationsView?.uuid) {
    return `/conversations/${allConversationsView.uuid}`
  }

  // Second priority: Check if user has live conversation permission
  if (viewsData?.hasLiveConversationPermission) {
    return '/conversations/live-conversations'
  }

  // Third priority: Fallback to the first available view with valid uuid
  const firstView = viewsData?.favourites?.[0] || viewsData?.publicViews?.[0]
  if (firstView?.uuid) {
    return `/conversations/${firstView.uuid}`
  }

  // Final fallback to /conversations/active/c (detail view for active conversations)
  return '/conversations/active/c'
}
